import React, { Component } from "react";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import ReactDOM from 'react-dom'; 
import { LangContext } from "../LangContext.jsx";
import FrequencyCreator from './FrequencyCreator';
import DocumentFields from "./DocumentFields.jsx";
class GeneralDocumentForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
                title:'',
                frequencyType:'once',
                mimes:[],
                selectedMimes: [],
                instructions:'',
                selectedFields: [],
                fv:'',
                is_automatic:0,
                active:true,
                deleteTemplate: 'off',
                hasTemplate:false,
                titleExists: false,
                titleChecking: false,
                titleMessage: '',
        };
        this.documentFields = React.createRef();
        this.titleCheckTimeout = null;
    } 
    handleTitleChange = (e) => {    
        const title = e.target.value;
        this.setState({ title });
        this.debouncedCheckTitle(title);
    } 

    debouncedCheckTitle = (title) => {
        if (this.titleCheckTimeout) {
            clearTimeout(this.titleCheckTimeout);
        }

        const normalizedTitle = (title || '').trim();

        if (normalizedTitle.length < 3) {
            this.setState({
                titleExists: false,
                titleChecking: false,
                titleMessage: ''
            });
            return;
        }

        this.setState({ titleChecking: true });
        this.titleCheckTimeout = setTimeout(() => {
            this.checkTitleAvailability(normalizedTitle);
        }, 450);
    }

    checkTitleAvailability = async (title) => {
        try {
            const response = await axios.post('/api/documents/check-title', { title });
            const exists = response?.data?.exists === true;
            this.setState({
                titleExists: exists,
                titleChecking: false,
                titleMessage: exists ? (response?.data?.message || 'Ya existe una plantilla con este nombre.') : ''
            });
        } catch (error) {
            this.setState({
                titleChecking: false,
                titleExists: false,
                titleMessage: ''
            });
        }
    }
    updateParentState = (updatedState) => {
        this.setState(updatedState);
    }

    componentWillUnmount() {
        if (this.titleCheckTimeout) {
            clearTimeout(this.titleCheckTimeout);
        }
    }
 
    async componentDidMount() {
        const { lang } = this.context; 
        if (Array.isArray(this.props.document) && this.props.document.length === 0) {
            // La prop `document` es un array vacío
        } else {
            
            this.setState({ title: this.props.document.title });
            const selectedMimes = this.props.document.mimes.map((m) => {
                return m.id
            })
            const selectedFields = this.props.document.fields.map((f) => { 
                return {
                    id: f.id,
                    document_field_type: f.document_field_type,
                    title: f.title,
                    placeholder: f.placeholder,
                    required: f.required,
                    conditions:f.validations, 
                }
            })

            this.props.document.template != null ? this.setState({'hasTemplate':true}) : this.setState({'hasTemplate':false});
            this.setState({'template':this.props.document.template})

            this.setState({ 
                title: this.props.document.title + ' - copia', 
                selectedFields: selectedFields,
                selectedMimes: selectedMimes
            });
        }
        await this.getMimes()
        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                extensions: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.necesitas_especificar_los_formatos_del_documento_antes_de_guardarlo')
                        },
                    }
                },
                title: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.nombre_requerido')
                        },
                        stringLength: {
                            min: 3,
                            max: 200,
                            message: lang.get('messages.el_nombre_debe_tener_una_longitud_minima_de_3')
                        },
                    }
                },
                size: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.peso_maximo_requerido')
                        },
                        digits: {
                            message: lang.get('messages.el_valor_debe_contener_solo_digitos')
                        },
                        stringLength: {
                            min: 1,
                            max: 4,
                            message: lang.get('messages.peso_incorrecto')
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });
        this.setState({fv: fv});
        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => { 
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    this.save();
                }
            })
            let fields = [];
            fields = this.documentFields.current.state.fields
        })
    }
    save() {
        if (this.state.titleExists || this.state.titleChecking) {
            return;
        }

        window.blockUI();
        let fields = [];
        let all_fields = [];  
        fields = this.documentFields.current.state.fields
        all_fields = this.documentFields.current.state.all_fields 
        fields.forEach((el) => { el.required = false; });
        const emptyTitleFields = fields.filter((el) => el.title.trim() === ''); 
        const fieldsWithValidation = fields.filter((el) => el.hasValidation == true);
        let emptyFields = false; 
        const fieldsWithEmptyConditions = fieldsWithValidation.filter((el) => {
            if (el.conditions) {
                el.conditions.map(con =>{
                    if(con.param1 != 6 && con.param1 != 7 && con.param1 != 8){
                        if(con.param2 == '' ){
                            emptyFields = true
                        }
                    } 
                })
            }
            return el.conditions === undefined || el.conditions.length === 0;
        });  
        if(emptyFields == true){
            swal.fire({
                text: `Contienes condiciones sin valores, favor de revisar`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }
        if(fieldsWithEmptyConditions.length > 0){
            swal.fire({
                text: `Todas las validaciones automaticas deben contener al menos una condición`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }
        if (emptyTitleFields.length > 0) {
            const emptyFieldIds = emptyTitleFields.map((el) => el.type);
            swal.fire({
                text: `Por favor, completa los títulos de los campos adicionales de tipo: ${emptyFieldIds.join(', ')}`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }  
        if (this.state.active) {
            KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        } else {
            KTUtil.btnWait(KTUtil.getById('btnSave'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        }
        const params = JSON.stringify({
            every: this.state.every,
            repeat_on: this.state.repeatOn,
            ends: this.state.ends,
            cicles: this.state.cicles,
            day_of_week: this.state.dayOfWeek,
            month_frequency_type: this.state.monthFrequencyType,
            refer_day: this.state.ReferDay,
            day: this.state.day,
            day_of_month: this.state.dayOfMonth,
            month_of_year: this.state.monthOfYear,
            instructions:this.state.instructions,
            title: this.state.title,
            frequency: this.state.frequencyType,
            size: 10,
            is_automatic: this.state.is_automatic,
            cfdi_id: this.state.cfdi,
            api_method: this.state.api_method,
            mimes: this.state.selectedMimes,
            required: true,
            active: this.state.active,
            fields: fields,
            all_fields: all_fields,
            period: this.state.period,
            type_id:  1,
            displayCfdiInput:this.state.displayCfdiInput,
            template:this.state.template,
            
            deleteTemplate: this.state.deleteTemplate,
            dateValidationComponentId:this.state.dateValidationComponentId, 
        }) 
        this.create(params)
    }
    async create(params) {   
        const { lang } = this.context; 
        var form = document.getElementById("frm");
        var formData = new FormData(form);
        
        await axios.post(
            '/api/documents', params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            if($('#template').val() != ''){
                let documentId = response.data.id;
                axios.post('/api/documents/template/'+documentId,formData).then(res=>{
                })
            }
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: lang.get('messages.guardado'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/documents';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    async getMimes() {
        const res = await axios.get('/api/mimes')
        const filteredMimes = res.data.filter(mime => mime.id !== 5); 
        this.setState({ mimes: filteredMimes }); 
    }
    handleMimeChanged = (e) => {
        const v = parseInt(e.target.value);
        if (e.target.checked) {
            this.setState(prevState => ({
                selectedMimes: [...prevState.selectedMimes, v],
            }) )
        } else {
            const selectedMimes = [...this.state.selectedMimes];
            const index = selectedMimes.indexOf(v);
            if (index > -1) {
                selectedMimes.splice(index, 1);
                this.setState({ selectedMimes: selectedMimes } );
            }
        }
    }
    handleDeleteTemplate = (e)=>{
        let dFlag = e.target.value;
        if (dFlag == "off") {
            this.setState({ deleteTemplate: "on" })
        } else {
            this.setState({ deleteTemplate: "off" })
        }
    }
    handleInstructionsChange = (e) =>{
        this.setState({
            instructions: e.target.value
        });
    }
    render() {
        const { lang } = this.context; 
        return (
            <form id="frm" encType="multipart/form-data"> 
            <div className="card card-custom gutter-b">
                <div className="card-body">
                    <div className="d-flex">
                        <div className="flex-grow-1">
                            <div className="row justify-content-center text-left">
                                <div className="col-sm-6 form-group">
                                    <label className="text-left">{lang.get('messages.nombre')}</label>
                                    <input  onChange={this.handleTitleChange}  id="title"  type="text"  autoFocus  className="form-control form-control-solid"  name="title"  value={this.state.title}/>
                                    {this.state.titleExists && (
                                        <small className="text-danger d-block mt-1">{this.state.titleMessage}</small>
                                    )}
                                </div>
                                <div className="col-sm-6 form-group">  
                                    <FrequencyCreator updateParentState={this.updateParentState} type={this.state.frequencyType} documentType={1} document={this.props.document} category={this.props.category} /> 
                                </div>
                            </div>
                            <div className="text-left mt-6">
                                <label className="text-left">{lang.get('messages.formatos')}</label>
                                <div className="checkbox-inline form-group">
                                    {this.state.mimes.map(({id, title}) => {
                                        return(
                                            <label  key={id}  className="checkbox checkbox-lg checkbox-square">
                                                <input  type="checkbox"  name="extensions"   value={id}   checked={this.state.selectedMimes.includes(id)}  onChange={this.handleMimeChanged}   />
                                                <span></span>
                                                {title}
                                            </label>
                                        )
                                    })}
                                </div>
                                <strong className="mt-6 d-block">{lang.get('messages.maximo_10_mb_por_archivo')}</strong>
                                <div className="form-group mt-8">
                                    <label className="text-left">{lang.get('messages.instrucciones_de_llenado_de_plantilla')}</label>
                                    <textarea className="form-control" value={this.state.instructions} name="instructions" onChange={this.handleInstructionsChange }></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="pl-10" style={{ maxWidth:'300px' }}> 
                            { this.state.hasTemplate == false &&
                                <div className="form-group mt-5"> 
                                    <label className="text-left">{lang.get('messages.'+this.props.upload_document_template)}</label>
                                    <input id="template" className="form-control "  type="file" name="template"/>
                                </div>
                            }
                            { this.state.hasTemplate &&
                                <div>
                                    <div className="form-group mt-5">
                                        <div className="text-left">
                                        {this.props.document_form_label} 
                                            <label>{lang.get('messages.'+this.props.update_document_template)}</label>
                                        </div>
                                        <div>
                                            <input id="template" className="form-control" type="file" name="template"/>
                                        </div>
                                        <div className="checkbox-inline mt-4">
                                            <label className="checkbox checkbox-sm checkbox-square">
                                                <input type="checkbox" id="delete-template" className="form-control" name="delete_template" value={this.state.deleteTemplate} onClick={ this.handleDeleteTemplate}/>
                                                <span></span> 
                                                {lang.get('messages.'+this.props.delete_document_template)}
                                            </label>
                                        </div>
                                        <div className="text-md-left mt-4 mb-2"> 
                                            <a download target="_blank" href={"/documents/" + this.props.document.id + "/template"} className="btn btn-primary btn-sm font-weight-bolder px-5">{lang.get('messages.'+this.props.download_document_template)}</a>
                                        </div>
                                    </div>
                                </div>
                            }
                            
                        </div>
                    </div> 
                    <DocumentFields ref={this.documentFields} document={this.state.document} updateSelectedDateValidationComponent={this.updateStateDateValidation} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/>
                </div>
                <div className="text-right gap-1 mr-10 mb-10">
                    <a href="/documents" className="btn btn-lg btn-secondary">
                        {lang.get('messages.cancelar')}
                    </a>
                    <button id="btnPublish" type="button" className="btn btn-lg btn-primary ml-4" disabled={this.state.titleExists || this.state.titleChecking}>
                        {lang.get('messages.guardar')}
                    </button>
                </div> 
            </div>
            </form>
        )
    }
}

export default GeneralDocumentForm;

if (document.getElementById('GeneralDocumentForm')) {
    ReactDOM.render(<GeneralDocumentForm />, document.getElementById('GeneralDocumentForm'));
}
